<template>
  <ion-badge color="secondary" data-test="label-badge">
    {{ props.label }}</ion-badge
  >
  <ion-badge v-if="props.time" id="timer" data-test="timer-badge">
    <p id="timer-text">
      {{ props.time + " " + props.timeUnit }}
    </p>
  </ion-badge>
</template>
<script setup lang="ts">
import { defineProps } from "vue";
import { IonBadge } from "@ionic/vue";
const props = defineProps({
  label: { type: String, required: true },
  time: { type: Number },
  timeUnit: { type: String },
});
</script>
